<template>
    <div class="w-100 position-relative">
        <div class="w-100">
            <FocusChart
                chart-type="violin"
                :chart-data="filteredDataByYear"
                :chart-overwrite-data="overwriteYearData"
                :chart-sort-override="chartSortOverride"
            />

            <FocusTable
                class="mt-md"
                :table-data="props.data"
                @filter-change="onFilterChange"
                :default-sort="[{ colId: 'momentum', sort: 'desc' }]"
            />
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'

import FocusChart from './shared/FocusChart.vue'
import FocusTable from './shared/FocusTable.vue'

const props = defineProps({
    data: {
        type: Array,
        default: () => [],
    },
    dataByYear: {
        type: Array,
        default: () => [],
    },
    allData: {
        type: Array,
        default: () => [],
    },
})

const overwriteYearData = ref([])
const filteredDataByYear = ref(props.dataByYear)
const chartSortOverride = ref([])

const onFilterChange = (data) => {
    const top10Names = data.slice(0, 10).map((item) => item.displayName)
    chartSortOverride.value = top10Names

    filteredDataByYear.value = props.dataByYear.map((yearObj) => {
        const filteredTechs = yearObj.productTechs.filter((tech) =>
            top10Names.includes(tech.displayName)
        )

        return {
            ...yearObj,
            productTechs: filteredTechs,
        }
    })
}
</script>
